import OpSdk, {MsService} from '@/sdk/OpSdk';

export interface ProductUpdateLog {
    yearMonthDay: number;
    items: ProductUpdateLogItem[];
}

export interface ProductUpdateLogItem {
    id: string;
    content: string;
}

export interface ListProductUpdateLogForm {
    pz: number;
    startYearMonthDay?: number;
    endYearMonthDay?: number;
    marker?: number;
}

export function listProductUpdateLog(form: ListProductUpdateLogForm): Promise<ProductUpdateLog[]> {
    return OpSdk.getInstance().getSimpleAjax(MsService.KK_USER).post('/op/fs/product/updateLog/list', form);
}

